export const CHART_LEFT_PADDING_FOR_LABELS = 50;
// Tick mark length for x and y axes
export const CHART_AXIS_TICK_LENGTH = 8;
// Buffer past last observation for stations without forecasts
export const OBSERVATION_END_BUFFER_MS = 2 * 60 * 60 * 1000;
// Extra padding to ensure scatter point (symbolSize: 12) is fully visible
// Use more padding when there's no forecast to ensure scatter point isn't cut off
export const SCATTER_POINT_PADDING_HOURS_NO_FORECAST = 6;
// Interval for x-axis split lines (one line per day)
export const CHART_SPLIT_LINE_INTERVAL_MS = 24 * 60 * 60 * 1000;

// Z-index layering for chart elements (bottom to top).
// ECharts default axisPointer z is 100.
export const CHART_Z_INDEX = {
  yAxisBackground: -2,
  forecastAreaFill: -1,
  watermark: 2,
  floodCategoryLines: 101,
  waterLevelLine: 103,
  floodCategoryLabels: 104,
  chartBorders: 104,
} as const;
